/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusVerlaufListResponseDto } from '../../models/lexplus-verlauf-list-response-dto';

export interface ErlassDetailControllerGetErlassNotizVerlaufV1$Params {
  erlassID: number;
  verlaufID: string;
  page?: number;
  limit?: number;
}

export function erlassDetailControllerGetErlassNotizVerlaufV1(http: HttpClient, rootUrl: string, params: ErlassDetailControllerGetErlassNotizVerlaufV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusVerlaufListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, erlassDetailControllerGetErlassNotizVerlaufV1.PATH, 'get');
  if (params) {
    rb.path('erlassID', params.erlassID, {});
    rb.path('verlaufID', params.verlaufID, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusVerlaufListResponseDto>;
    })
  );
}

erlassDetailControllerGetErlassNotizVerlaufV1.PATH = '/v1/compliance/erlasse/{erlassID}/notizen/{verlaufID}/verlauf';
